import { CourseInfo, SubjectTarget } from "../../../types/gqlTypes/graphql"

export const DEFAULT_ERROR_MESSAGE =
  "An error occurred. Please exit the page then try again. If the error persists, contact support for help."

// Thrown by getScoresByStudent when no subject can be resolved.
export const NO_SUBJECT_SELECTED_ERROR = "NO_SUBJECT_SELECTED"

export const SUBJECTS_WITH_HALF_HOUR_STEP = {
  KSA: {
    "On-Demand Writing": true
  }
}

export const HAS_COMBINED_SCORE_LABEL_TAG = "HasCombinedScore"

export const COMBINED_PAGE_NAME = "Overall"

export const COMBINED_SUBJECT_TAB: SubjectTarget = {
  name: "Overall",
  available: true
}

export const COMBINED_COURSE_INFO: CourseInfo = {
  name: "Overall",
  courseCategories: ["science"]
}
